import React from "react"
import { MainCP } from "../../Components/atributos-politicos/MainCP"

const ViewAtributosPoliticos: React.FC = () => <MainCP/>

export default ViewAtributosPoliticos